export default {
  form: {
    hints: {
      contract: {
        // cable_modem_bin: 'Archivo binario DOCSIS personalizado para este contrato.',
        // cable_modem_enabled: 'Funciona solo para versiones de BMU mayores o igual a 0.7.0.',
        coverage_id: 'Nodo -> Cobertura (D: Distancia al nodo)',
        // dhcp_server: 'Sólo es necesario para MikroTik',
        ip_address: 'El autocompletador de ips libres se activará luego de los 6 caracteres',
        massive_update: {
          mikrotik_interface_id: 'Solo aparecerán las interfaces marcadas como LAN',
          plan_id: 'Si cambia el plan, se auto propagará el precio y la frecuencia'
        },
        mikrotik_interface_id:
          'Interfaz donde está conectado físicamente el contrato. Esta opción es solo necesaria para Mikrotik, requerida para ARP y buscador de mac address.',
        nap_id: 'NAP -> [Disponibilidad] (D: Distancia a la NAP)',
        ppp_profile:
          'Perfil que se utilizará para crear los secrets PPPoE. Esta opción es solo necesaria para MikroTik. Nota: En caso de que no muestre la opción, primero importe los PPP Profile desde la vista del servidor.',
        public_address:
          'Dirección que se utilizara para realizar FULL-NAT con la IP del contrato. MikroTik: Solo podrá seleccionar direcciones de aquellas interfaces marcadas como WAN. En caso de utilizar una dirección para FULL-NAT, no se podrá realizar redirecciones de puertos o asignar a otro contrato.'
      },
      invoicing: {
        recurring_item: {
          lapse:
            'Valor numérico que indica por cuántos períodos se cobrará este item. Por ejemplo en un contrato mensual, es la cantidad de meses en las que se cobrará este item. Si el valor queda en blanco este item se cobrará en cada período infinitamente.'
        }
      },
      employee: {
        zones:
          'La zonas seleccionadas, solo permitirá a ese empleado ver a los clientes y todo lo relacionado que tengan la misma zona. En caso de dejar el campo vació podrá a ver a TODOS los clientes.'
      },
      client: {
        invoicing_client_attributes: {
          start_invoicing_day:
            'Cambiar el día a facturar afectará a todos los contratos, y será efectivo a partir del próximo periodo a facturar',
          vat_condition: 'Condición IVA del cliente (Receptor)'
        }
      }
    },
    no_matches_found: 'No hay coincidencias',
    required: 'Requerido',
    save_btn: 'Guardar',
    select_input: 'Seleccione una opción',
    show_less: 'Mostrar menos',
    show_more: 'Mostrar más'
  }
};
